"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  TITLE: "Oops! Something went wrong",
  TEXT: "Check your internet connection and try again.",
  BUTTON_TEXT: "Retry",
  TRYING_AGAIN: "Retrying, please wait..."
};